import { ApiResponse } from 'types/api';
import { AuthResponse, LoginRequest, SignupRequest } from 'types/auth';

import { apiRequest } from 'services/api/client';

export type ChangePasswordRequest = {
  old_password: string;
  new_password: string;
};

export const authService = {
  login(payload: LoginRequest) {
    return apiRequest<AuthResponse>('/auth/login', {
      method: 'POST',
      body: payload,
    });
  },

  signup(payload: SignupRequest) {
    return apiRequest<AuthResponse>('/auth/signup', {
      method: 'POST',
      body: payload,
    });
  },

  changePassword(payload: ChangePasswordRequest) {
    return apiRequest<ApiResponse<Record<string, unknown>>>('/auth/change-password', {
      method: 'POST',
      body: payload,
      auth: true,
    });
  },
};
